var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpenRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 105,
    viewBox: "0 0 53 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13_912)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.5 -2.12e-06C39.637 -1.55774e-06 27.3008 5.10981 18.2053 14.2053C9.1098 23.3008 4 35.637 4 48.5C4 61.363 9.1098 73.6992 18.2053 82.7947C27.3008 91.8902 39.637 97 52.5 97L52.5 48.5L52.5 -2.12e-06Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.65527 48.2332C7.79438 47.6366 7.79438 46.3629 8.65527 45.7664L21.8936 36.5955C22.8883 35.9063 24.2479 36.6178 24.248 37.8279L24.248 56.1716C24.2479 57.3817 22.8883 58.0932 21.8936 57.4041L8.65527 48.2332Z",
    fill: "#91E2CA",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.498 47.866C18.8314 47.4811 18.8314 46.5184 19.498 46.1335L40.498 34.0095C41.1647 33.6246 41.998 34.1059 41.998 34.8757L41.998 59.1238C41.998 59.8936 41.1647 60.3749 40.498 59.99L19.498 47.866Z",
    fill: "#5DAF97",
    stroke: "white",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13_912",
    x: 0,
    y: 0,
    width: 56.5,
    height: 105,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13_912"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13_912",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenRight);
export default __webpack_public_path__ + "static/media/open_right.3a888eb521b54783fb001aa5e1b015e1.svg";
export { ForwardRef as ReactComponent };